import { motion } from "framer-motion";
import { EASE } from "./Motion";

export const Intro = () => (
  <motion.div
    initial={{ y: "0%" }}
    animate={{ y: "-100%" }}
    transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1], delay: 1.1 }}
    className="pointer-events-none fixed inset-0 z-[100] flex items-center justify-center bg-[#14120F]"
    data-testid="intro-curtain"
  >
    <div className="flex flex-col items-center gap-6">
      <motion.img
        src="/assets/icon-light.png" alt=""
        initial={{ opacity: 0, scale: 0.92, filter: "blur(8px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="h-16 w-auto sm:h-20"
      />
      <div className="h-px w-40 overflow-hidden bg-white/15">
        <motion.div initial={{ x: "-100%" }} animate={{ x: "0%" }} transition={{ duration: 0.9, ease: EASE, delay: 0.1 }} className="h-full w-full bg-[#C9A96E]" />
      </div>
    </div>
  </motion.div>
);
